import React from 'react'
import mockServices from '../../Components/Test/Test.component.services'
import { Services } from 'types/Services'

/**
 * Here we create a [`Context`](https://reactjs.org/docs/context.html) using React's new Context API. The first and only argument to `React.createContext()`
 * is used as a fallback value. In the event that there is no `<ServicesContext.Provider />` provided higher up in the tree than `<ServicesContext.Consumer />`,
 * the default value will be provided.
 *
 * We can exploit this fact with providing a default value of our `mockServices`.
 *
 * The exploitation works by guarenteeing that our `<Entry />` points all include a child `<ServicesContext.Provider value={services} />` within their tree.
 *
 * This means that from within each `<Entry />`, the real services have been provided to the `ServicesContext.Provider` via the `value` prop. The real services
 * will then override the fallback argument of our `mockServices`.
 */

const ServicesContext = React.createContext<Services>(mockServices as Services)

export default ServicesContext
